import { type Theme } from "@mui/material";
import { type Components } from "@mui/material/styles";

import { applyPlatformAwareInteractionStyles } from "../utils/applyPlatformAwareInteractionStyles";

export const muiToggleButtonOverrides: Components<Theme> = {
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.borderRadius?.large,
        padding: theme.spacing(1),
        justifyContent: "space-between",
        width: "-webkit-fill-available",
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
      }),
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        textTransform: "none",
        borderWidth: `${theme.borderWidth?.regular} !important`,
        padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
        borderRadius: `${String(theme.borderRadius?.xLarge)} !important`,
        backgroundColor: theme.palette.background.primary,
        color: theme.palette.text.primary,
        height: theme.size?.button?.small.height,
        fontWeight: theme.typography.fontWeightMedium,
        margin: `0 !important`,
        transition: theme.transitions.create(
          ["border-color", "background-color", "opacity", "color"],
          {
            duration: theme.transitions.duration.short,
          }
        ),

        ...applyPlatformAwareInteractionStyles({
          hoverStyle: {
            borderColor: theme.palette.text.primary,
            borderWidth: theme.borderWidth?.regular,
            backgroundColor: theme.palette.background.tertiary,
            opacity: 1,
          },
          defaultStyle: {
            borderColor: "transparent",
            backgroundColor: theme.palette.background.primary,
          },
        }),

        "&.Mui-disabled": {
          backgroundColor: theme.palette.background.primary,
          color: theme.palette.intent?.disabled.text,
          borderColor: "transparent",
        },

        "&.Mui-selected": {
          // mui sets border-left: 0 (as it renders toggle buttons in one group)
          // with a pretty complex selector so we need to override it (color + style)
          borderColor: `${theme.palette.text.primary} !important`,
          borderStyle: "solid !important",
          backgroundColor: `${theme.palette.background.tertiary}`,

          // need this to override the default hover style mui sets
          ...applyPlatformAwareInteractionStyles({
            hoverStyle: {
              backgroundColor: theme.palette.background.tertiary,
            },
            defaultStyle: {
              backgroundColor: theme.palette.background.tertiary,
            },
          }),
        },
      }),
    },
  },
};
